"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useFetchingPagination_1 = __importDefault(require("./useFetchingPagination"));
const useMemoryPagination_1 = __importDefault(require("./useMemoryPagination"));
function useCombinedPagination(rawItems, options = {}) {
    const { enable = true, perPage, page: current, total, fetchMore } = options;
    const isFetching = Boolean(fetchMore);
    const { nextPage: nextPageFetching, prevPage, page, items, hasMore, } = (0, useFetchingPagination_1.default)(rawItems, {
        enable: Boolean(enable && isFetching),
        perPage,
        fetchMore,
        page: current,
        total,
    });
    const { nextPage: nextPageMemory, prevPage: prevPageMemory, page: pageMemory, items: itemsMemory, hasMore: hasMoreMemory, } = (0, useMemoryPagination_1.default)(rawItems, {
        enable: Boolean(enable && !isFetching),
        perPage,
    });
    return {
        nextPage: isFetching ? nextPageFetching : nextPageMemory,
        prevPage: isFetching ? prevPage : prevPageMemory,
        page: isFetching ? page : pageMemory,
        items: isFetching ? items : itemsMemory,
        hasMore: isFetching ? hasMore : hasMoreMemory,
    };
}
exports.default = useCombinedPagination;
//# sourceMappingURL=useCombinedPagination.js.map